import site from '../config/site';
import { SERVICES } from '../data/services';

export function organizationSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: site.legalName,
    alternateName: site.shortName,
    url: site.siteUrl,
    email: site.email.label,
    telephone: site.phone.label,
    foundingDate: String(site.foundedYear),
    sameAs: [site.social.instagram.href],
    address: {
      '@type': 'PostalAddress',
      addressLocality: 'Ciudad de Panamá',
      addressCountry: 'PA',
    },
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: site.phone.label,
      contactType: 'sales',
      email: site.email.label,
      availableLanguage: ['Spanish'],
    },
  };
}

export function localBusinessSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    name: site.legalName,
    url: site.siteUrl,
    telephone: site.phone.label,
    email: site.email.label,
    address: {
      '@type': 'PostalAddress',
      addressLocality: 'Ciudad de Panamá',
      addressCountry: 'PA',
    },
    openingHoursSpecification: [
      {
        '@type': 'OpeningHoursSpecification',
        dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
        opens: '08:00',
        closes: '17:00',
      },
      {
        '@type': 'OpeningHoursSpecification',
        dayOfWeek: ['Saturday'],
        opens: '08:00',
        closes: '13:00',
      },
    ],
  };
}

export function serviceListSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    itemListElement: SERVICES.map((service, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      item: {
        '@type': 'Service',
        name: service.title,
        description: service.summary,
        provider: { '@type': 'Organization', name: site.legalName },
        areaServed: { '@type': 'Country', name: 'Panamá' },
      },
    })),
  };
}

export function faqSchema(items) {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: items.map(item => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: { '@type': 'Answer', text: item.answer },
    })),
  };
}

export function breadcrumbSchema(items) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.label,
      ...(item.href ? { item: `${site.siteUrl}${item.href}` } : {}),
    })),
  };
}

export function webSiteSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'Soluciones e Integraciones Eléctricas S.A.',
    alternateName: ['SIESA', 'SIESA Panamá'],
    url: site.siteUrl,
  };
}

export const jsonLd = schema => JSON.stringify(schema);
